import { Component, inject } from '@angular/core';
import { NavigationCancel, NavigationCancellationCode, NavigationError, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { LoaderComponent } from "./shared/components/loader/loader.component";
import { LoaderService } from './shared/services/loader.service';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, LoaderComponent],
    templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'Misión Empresarial';

  private readonly router = inject(Router);
  private readonly loader = inject(LoaderService);

  constructor() {
    // Una navegación que falla o se cancela deja al usuario donde estaba, y si venía con
    // el loader arriba (login: "Cargando información del usuario...") la pantalla quedaba
    // bloqueada sin explicación. Se libera el overlay y el fallo queda en consola.
    this.router.events
      .pipe(filter((e): e is NavigationError | NavigationCancel => e instanceof NavigationError || e instanceof NavigationCancel))
      .subscribe((e) => {
        this.loader.hide();
        this.registrarNavegacionNoCompletada(e);
      });
  }

  /**
   * Redirección (guard que devuelve otra ruta) y reemplazo por otra navegación son flujo normal:
   * al abrir '/' el layout ya lanza la navegación a la última pantalla y cancela la inicial. No
   * se registran para no ensuciar la consola con un "error" que no lo es. El resto se escribe
   * legible (URL + motivo), sin el objeto minificado del evento.
   */
  private registrarNavegacionNoCompletada(e: NavigationError | NavigationCancel): void {
    if (e instanceof NavigationError) {
      console.error(`[Router] Navegación fallida a ${e.url}:`, e.error);
      return;
    }
    if (e.code === NavigationCancellationCode.Redirect || e.code === NavigationCancellationCode.SupersededByNewNavigation) {
      return;
    }
    const codigo = e.code !== undefined ? NavigationCancellationCode[e.code] : 'sin código';
    console.warn(`[Router] Navegación cancelada a ${e.url} (${codigo})${e.reason ? ': ' + e.reason : ''}`);
  }
}
